import { PlanInterface } from '../types';

export function deserializePlan(plan: PlanInterface): PlanInterface {
  return {
    ...plan,
    costPerSeat: typeof plan.costPerSeat === 'string' ? parseInt(plan.costPerSeat) : plan.costPerSeat,
  };
}
